import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { supportedPreviewExtensions } from 'Consts/EnumeratedValues';
import { ParentSize } from '@visx/responsive';
import PdfViewer from 'Components/ClientApp/CombinedApp/Viewport/SecureFiles/Mobile/PdfViewer';
import useMobileLayout from 'Hooks/useMobileLayout';
import Previewable from './Previewable';
import Downloadable from './Downloadable';

function isPreviewable(filename) {
  const extArray = filename.split('.');
  const ext = extArray[extArray.length - 1];

  return supportedPreviewExtensions.indexOf(ext.toLowerCase()) > -1;
}

const styles = () => ({
  preview: {},
  download: {},
});

const Preview = ({ classes, presentsAsDownloadable, ...rest }) => {
  const { fileName } = rest;
  const isMobile = useMobileLayout();
  const fileType = fileName.split('.').pop().toLowerCase();

  if (isPreviewable(fileName)) {
    return isMobile && fileType === 'pdf' ? (
      <ParentSize>
        {parent => (
          <PdfViewer
            fileName={fileName}
            parent={parent}
            {...rest}
          />
        )}
      </ParentSize>
    ) : (
      <Previewable
        className={classes.preview}
        {...rest}
      />
    );
  }

  if (!presentsAsDownloadable) {
    return null;
  }

  return (
    <Downloadable
      className={classes.download}
      {...rest}
    />
  );
};

Preview.propTypes = {
  classes: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  presentsAsDownloadable: PropTypes.bool,
};

export default withStyles(styles)(Preview);
